<template>
  <div class="module">
    <h3 class="h3" v-if="objData[name].title">{{objData[name].title}}</h3>
    <p v-if="objData[name].p" v-html="objData[name].p"  :class="objData[name].pclass"></p>
    <img v-if="objData[name].img!=null" :src="objData[name].img.imgsrc" :class="objData[name].img.class">
    <p class="bp" v-if="objData[name].bp" v-html="objData[name].bp"></p>
    <div  v-if="objData[name].ullist&&objData[name].ullist!=null">
      <ul :class="objData[name].class">
        <li v-for="(item,index) in objData[name].ullist" :key="index">
          <div>
            <img v-if="item.src" :src="item.src" alt="">
            <h4 v-if="item.title">{{item.title}}</h4>
          </div>
          <p v-if="item.p" v-html="item.p"></p>
        </li>
      </ul>
    </div>
  </div>
</template>
<style>
</style>
<script>
import Text from '../utils/text'
export default {
  props:{
    obj:String,
    name:String
  },
  data(){
    return {
      objData:{}
    }
  },
  created(){
    this.objData = Text.websiteText[this.obj]
  }
}
</script>
<style lang="scss">
  .module{
    margin-top:27px;
    h3{
      font-size:36px;
      line-height:76px;
      font-weight: bold;
      text-align: center;
      margin-top:45px;
      margin-bottom:20px;
    }
    p{
      padding:0 25px;
      font-size:28px;
      line-height:50px;
      text-align: justify;
      margin-bottom:45px;
    }
    img{
      display: block;
      max-width:705px;
      margin:0 auto 50px;
    }
    .pclass{
      text-align: center;
    }
  }
  .modular2{
    @include flex($just:'space-between');
    flex-wrap:wrap;
    margin-top:40px;
    li{
      width:50%;
      text-align: center;
      margin-bottom:30px;
      h4{
        font-size:30px;
        color:#333;
        line-height:80px;
        font-weight: bold;
      }
      p{
        font-size:24px;
        line-height:40px;
        color:#666;
        text-align:center;  
      }
      img{
        display: block;
        margin:0 auto;
        width:232px;
        height:212px;
      }
    }
  }
  .modular3{
    padding:0 25px;
    li{
      margin-bottom:25px;
      h4{
        font-size:28px;
        color:#333;
        padding-left:30px;
        line-height:50px;
        font-weight: bold;
        background:url('../assets/img/quan.png') left center no-repeat;
        background-size:23px 22px;
      }
      p{
        color:#666;
        font-size:24px;
      }
    }
  }
  .modular4{
    @include flex($just:'space-between');
    flex-wrap:wrap;
    li{
      p{
        background:url('../assets/img/quan.png') 0 15px no-repeat;
        background-size:23px 22px;
        padding-left:30px;
        box-sizing: border-box;
        font-size:28px;
        color:#666;
      }
      padding-left:40px;
      // width:33.33333%
    }
    & li:last-child{padding-left:0;}
    & li:nth-child(3){padding-left:80px;}
  }
  .bp{
    margin:47px 0 20px;
    font-size:28px;
    color:#333;
  }
  .crmModular1{
    @include flex($just:'space-between');
    flex-wrap:wrap;
    margin-bottom:45px;
    li{
      margin-top:45px;
      width:50%;
      img{
        display:block;
        width:120px;
        height:120px;
        margin: 0 auto 30px;
      }
      p{
        text-align:center;
        font-size:28px;
        color:#666;
      }
    }
  }
  .crmModular2{
    li{
      img{
      height:190px;
      width:190px;
     }
    }
  }
  .agentModular2{
    margin:54px 28px 0;
    li{
      border:1px solid #dbdbdd;
      width:100%;
      height:220px;
      @include flex;
      margin-bottom:23px;
      box-shadow:0 3px 6px 2px #c7e4fe;
      &>div{
        width:190px;
        background:#44b5f2;
        // @include center;  
        display:flex;
        color:#fff;
        flex-direction: column;
        text-align:center;
        align-items: center;
        justify-content:center;
        
        img{
          width:63px;
          height:63px;
        }
        h4{
          margin-top:-25px;
        }
      }
      p{
        width:606px;
        height:100%;
        line-height:46px;
        font-size:24px;
        color:#333;
        box-sizing:border-box;
        @include flex($align:center)
      }
    }
  }
  .agentModular3{
    margin:50px auto;
    li{
      margin:0 auto;
      width:693px;
      height:60px;
      background:url('../assets/img/busagent-img2.png') no-repeat;
      background-size:contain;
      margin-bottom:18px;
      p{
        font-size:28px;
        text-align: center;
        line-height: 57px;
      }
    }
  }
  .aboutModu{
    margin:40px 27px 0;
     li{
      border:2px solid #cccccc;
      margin-bottom:50px;
      border-radius:30px;
      p{
        padding:60px 50px 40px ;
      }
      h4{
        width:400px;
        height:64px;
        background:#1cacfa;
        border-radius:10px;
        color:#fff;
        text-align: center;
        line-height:64px;
        margin:-32px 0 0 148px;
      }
     }
  }
  .robotModular2{
    @include flex($just:space-between); 
    flex-wrap:wrap;
    margin-bottom:100px;
    $width:670px;
    height:510px;
    background:url('../assets/img/robot-img1.png')  75px 0 no-repeat;
    background-size:620px 510px;
    li{
      width:$width/3;
      text-align: center;
      height:140px;
      margin-bottom:65px;
      padding-top:110px;
      box-sizing: border-box;
    }
    li:nth-child(3n){
      padding-left:20px;
      // background:red;
    }
  }
  .robotModular3{
     @include flex($just:space-between); 
     flex-wrap: wrap;
     background:url('../assets/img/robot-img3.png') center 150px no-repeat;
     background-size:515px 501px;
     p{
       font-size:22px;
       color:#666;
       line-height:38px;
       em{
         background:#d8edfd;
         color:#333;
         font-size:28px;
         padding:5px 10px;
         border-radius:10px;
         font-weight: bold;
       }
     }
    li:first-child{
        width:100%;
    }
    li:nth-child(2){
      width:220px;
      margin-right:200px;
      margin-top:50px;
    }
    li:nth-child(3){
      width:215px;
      margin-top:10px;
    }
    li:nth-child(4){
      width:405px;
      margin-top:150px;
    }
     li:nth-child(5){
      width:255px;
      margin-top:50px;
    }
  }
  .robotModular4{
     @include flex($just:space-between); 
     margin-top:40px;
     flex-wrap: wrap;
     $width:720px;
     background:url('../assets/img/robot-img2.png') center 0 no-repeat;
     background-size:660px 459px;
    li{
      width:$width/3;
      text-align: center;
      height:270px;
      padding-top:150px;
      margin-bottom:60px;
      box-sizing: border-box; 
      line-height:40px;
      h4{
        font-size:28px;
        color:#333333;
        margin-bottom:10px; 
      }
      p{
        padding:0;
        text-align: center;
        font-size:22px;
        color:#666;
      }
    }
  }
</style>
